import { combineReducers } from 'redux'
import { authReducer } from './authReducer'
import { itemReducer } from './itemReducer'
import { orderReducer } from './orderReducer'
import { delivereeReducer } from './delivereeReducer'
import { restaurantReducer } from './restaurantReducer'
import { menuReducer } from './menuReducer'
import { tagReducer } from './tagReducer'
import { driverReducer } from './driverReducer'
import { partnerReducer } from './partnerReducer'
import { sponsorReducer } from './sponsorReducer'
import { popularReducer } from './popularReducer'
import { rolePermissionReducer } from './rolePermissionReducer'
import { userReducer } from './userReducer'
import { dashboardReducer } from './dashboardReducer'
import { recentListReducer } from './recentListReducer'
import { itemOptionReducer } from './itemOptionReducer'
import { driverSegmentReducer } from './driverSegmentReducer'
import { dynamicFeeReducer } from './dynamicFeeReducer'
import { driverIncentiveReducer } from './driverIncentiveReducer'
import { mapViewReducer } from './mapViewReducer'
import { cashOutReducer } from './cashOutReducer'
import { appInboxReducer } from './appInboxReducer'
import { merchantSettlementReducer } from './merchantSettlementReducer'
import { expressReducer } from './expressReducer'
import { regionReducer } from './regionReducer'
import { unavailableItemReducer } from './unavailableItemReducer'
import { hasuraOrderReducer } from './hasuraOrderReducer'
import { hasuraItemReducer } from './hasuraItemReducer'
import { hasuraSearchItemReducer } from './hasuraSearchItemReducer'
import { hasuraDataValidationReducer } from './hasuraDataValidationReducer'
import { delivereeReportReducer } from './delivereeReportReducer'
import { operatorReportReducer } from './operatorReportReducer'
import { locationReportReducer } from './locationReportReducer'
import { cartBasedPromotionReducer } from './cartBasedPromotionReducer'
import { promotionReducer } from './promotionReducer'
import { pickUpPromotionReducer } from './pickUpPromotionReducer'
import { specialDealReducer } from './specialDealReducer'
import { invoiceReducer } from './invoiceReducer'
import { deliveryFeeOfferReducer } from './deliveryFeeOfferReducer'
import { merchandiseCodeReducer } from './merchandiseCodeReducer'
import { driverTransactionReducer } from './driverTransactionReducer'
import { itemSyncReducer } from './itemSyncReducer'
import { delivererOrderReducer } from './delivererOrderReducer'
import { crossSellItemReducer } from './crossSellItemReducer'
import { appCustomizationReducer } from './appCustomizationReducer'
import { merchantCloseRequestReducer } from './merchantCloseRequestReducer'
import { ServiceAvailabilityReducer } from './serviceAvailabilityReducer'
import { freeCheckoutReducer } from './freeCheckoutReducer'
import { quantityPromotionReducer } from './quantityPromotionReducer'
import {luckyDrawWinnerReducer} from './luckyDrawWinnerReducer'

const rootReducer = combineReducers({
  auth: authReducer,
  tags: tagReducer,
  items: itemReducer,
  menus: menuReducer,
  orders: orderReducer,
  deliverees: delivereeReducer,
  restaurants: restaurantReducer,
  drivers: driverReducer,
  partners: partnerReducer,
  sponsors: sponsorReducer,
  popular: popularReducer,
  rolePermission: rolePermissionReducer,
  users: userReducer,
  dashboard: dashboardReducer,
  recentLists: recentListReducer,
  itemOptions: itemOptionReducer,
  driverSegments: driverSegmentReducer,
  dynamicFees: dynamicFeeReducer,
  driverIncentives: driverIncentiveReducer,
  mapView: mapViewReducer,
  cashOuts: cashOutReducer,
  appInboxes: appInboxReducer,
  merchantSettlements: merchantSettlementReducer,
  express: expressReducer,
  regions: regionReducer,
  unavailableItem: unavailableItemReducer,
  hasuraOrders: hasuraOrderReducer,
  hasuraItems: hasuraItemReducer,
  hasuraSearchItems: hasuraSearchItemReducer,
  delivereeReport: delivereeReportReducer,
  operatorReport: operatorReportReducer,
  cartBasedPromotions: cartBasedPromotionReducer,
  promotions: promotionReducer,
  pickUpPromotions: pickUpPromotionReducer,
  specialDeals: specialDealReducer,
  hasuraDataValidation: hasuraDataValidationReducer,
  invoice: invoiceReducer,
  deliveryFeeOffers: deliveryFeeOfferReducer,
  merchandiseCodes: merchandiseCodeReducer,
  driverTransactions: driverTransactionReducer,
  itemSync: itemSyncReducer,
  delivererOrders: delivererOrderReducer,
  orderLocations: locationReportReducer,
  crossSellItems: crossSellItemReducer,
  appCustomization: appCustomizationReducer,
  merchantCloseRequests: merchantCloseRequestReducer,
  serviceAvailability: ServiceAvailabilityReducer,
  freeCheckouts: freeCheckoutReducer,
  quantityPromotions: quantityPromotionReducer,
  luckyDrawWinners: luckyDrawWinnerReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js